(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-builder')) {
    customElements.define(
      'bundle-builder',
      class BundleBuilder extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          const cfg = this.querySelector('[data-config]');
          if (!cfg || !this.querySelector('[data-card]')) return;
          this._init = true;
          this.cfg = JSON.parse(cfg.textContent);
          if (!this.cfg.tiers.length) return;
          this.cfg.noCustom = (this.cfg.noCustom || []).map((x) => x.trim()).filter(Boolean);
          this.cfg.urduWords = (this.cfg.urduWords || []).map((x) => x.trim()).filter(Boolean);

          this.cards = Array.from(this.querySelectorAll('[data-card]'));
          this.pjs = this.cards.map((c) => JSON.parse(c.querySelector('[data-pj]').textContent));
          this.units = []; // { ci, v, name, defs, fields:[{name,label,value,file}] }
          this.cache = {};
          this.busy = false;
          this.loading = false;
          this.token = 0;
          this.shown = { total: null, save: null };
          this.prevActive = -1;
          this.uid = Math.random().toString(36).slice(2, 7);
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.topQty = Math.max(...this.cfg.tiers.map((t) => t.qty));
          this.minQty = Math.min(...this.cfg.tiers.map((t) => t.qty));
          this.maxItems = Math.max(this.cfg.maxItems || this.topQty, this.topQty);

          this.$ = (s) => this.querySelector(s);
          this.els = {
            count: this.$('[data-count]'), bar: this.$('[data-bar]'), progress: this.$('[data-progress]'),
            slots: this.$('[data-slots]'), value: this.$('[data-value]'), total: this.$('[data-total]'),
            save: this.$('[data-save]'), rowSave: this.$('[data-row-save]'), rowValue: this.$('[data-row-value]'),
            submit: this.$('[data-submit]'), label: this.$('[data-submit-label]'), price: this.$('[data-submit-price]'),
            msg: this.$('[data-msg]'), hint: this.$('[data-hint]'), pct: this.$('[data-pct]'),
            clear: this.$('[data-clear]'), none: this.$('[data-noresults]'), summary: this.$('[data-summary]'),
            tiers: this.$('[data-tiers]'), thumb: this.$('[data-thumb]'),
          };
          this.modal = this.$('[data-modal]');
          this.mForm = this.$('[data-modal-form]');
          this.mFields = this.$('[data-modal-fields]');
          this.mOpts = this.$('[data-modal-opts]');
          this.mError = this.$('[data-modal-error]');
          this.mLoading = this.$('[data-modal-loading]');
          this.mSave = this.$('[data-modal-save]');
          this.mCopyRow = this.$('[data-copy-row]');
          this.mAdvance = this.$('[data-advance]');

          // milestone ticks on the progress bar
          this.cfg.tiers.forEach((t) => {
            const tick = document.createElement('i');
            tick.className = 'bb-tick';
            tick.style.left = (t.qty / this.topQty) * 100 + '%';
            this.els.progress.append(tick);
          });

          this.cards.forEach((card, i) => {
            const min = Number(card.dataset.min) || 0;
            const varies = card.dataset.varies === 'true';
            card.querySelector('[data-price]').textContent = (varies ? 'From ' : '') + this.money(min);
            const cmp = Number(card.dataset.compare) || 0;
            const el = card.querySelector('[data-compare-el]');
            if (!varies && cmp > min) { el.hidden = false; el.textContent = this.money(cmp); }
            if (!this.pjs[i].variants.length) card.dataset.soldout = 'true';
          });

          this.addEventListener('click', (e) => this.onClick(e));
          this.addEventListener('pointerover', (e) => { const c = e.target.closest('[data-card]'); if (c) this.loadStatic(c.dataset.url); });
          this.addEventListener('touchstart', (e) => { const c = e.target.closest('[data-card]'); if (c) this.loadStatic(c.dataset.url); }, { passive: true });
          const search = this.$('[data-search]');
          if (search) search.addEventListener('input', () => this.filter(search.value));

          this.mForm.addEventListener('submit', (e) => { e.preventDefault(); this.saveModal(); });
          this.mForm.addEventListener('change', (e) => {
            const r = e.target.closest('[data-oi]');
            if (r) { this.sel[Number(r.dataset.oi)] = r.value; this.refreshVariant(); return; }
            if (e.target.closest('[data-k]')) this.applyCustomState();
          });
          this.mForm.addEventListener('input', (e) => {
            const c = e.target.closest('[data-k]');
            if (!c) return;
            const cnt = c.closest('.bb-field') && c.closest('.bb-field').querySelector('.bb-field__count');
            if (cnt && c.maxLength > 0) cnt.textContent = `${c.value.length}/${c.maxLength}`;
          });
          this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.modal.close(); });
          this.modal.addEventListener('close', () => { this.token++; this.editing = null; });

          let rz;
          const refit = () => { this.measureOffset(); this.moveThumb(true); };
          window.addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(refit, 120); });
          window.addEventListener('load', refit);
          [600, 1800, 4000].forEach((ms) => setTimeout(refit, ms));
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveThumb(true));

          this.measureOffset();
          this.render();
          this.moveThumb(true);
        }

        /* ---------- helpers ---------- */
        money(cents) {
          const f = this.cfg.moneyFormat || '{{amount}}';
          const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
          const type = m ? m[1] : 'amount';
          const v = cents / 100;
          const fmt = (n, d, t, dec) => {
            const [i, x] = n.toFixed(d).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (x ? dec + x : '');
          };
          const whole = Math.round(cents) % 100 === 0;
          let out;
          switch (type) {
            case 'amount_no_decimals': out = fmt(v, 0, ',', '.'); break;
            case 'amount_with_comma_separator': out = fmt(v, whole ? 0 : 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': out = fmt(v, 0, '.', ','); break;
            case 'amount_with_apostrophe_separator': out = fmt(v, whole ? 0 : 2, "'", '.'); break;
            case 'amount_no_decimals_with_space_separator': out = fmt(v, 0, ' ', '.'); break;
            default: out = fmt(v, whole ? 0 : 2, ',', '.');
          }
          return m ? f.replace(m[0], out) : out;
        }

        esc(s) {
          return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        }

        get total() { return this.units.length; }
        qtyOf(ci) { return this.units.reduce((n, u) => n + (u.ci === ci ? 1 : 0), 0); }

        /* highest discount level reached by the current number of products */
        activeIdx() {
          let a = -1;
          this.cfg.tiers.forEach((t, i) => { if (this.total >= t.qty && (a < 0 || t.qty >= this.cfg.tiers[a].qty)) a = i; });
          return a;
        }
        nextTier() {
          let best = null;
          this.cfg.tiers.forEach((t) => { if (t.qty > this.total && (!best || t.qty < best.qty)) best = t; });
          return best;
        }

        say(text, error) {
          this.els.msg.textContent = text || '';
          this.els.msg.classList.toggle('is-error', !!error);
        }

        filter(term) {
          const q = term.trim().toLowerCase();
          let shown = 0;
          this.cards.forEach((c) => {
            const hit = !q || c.dataset.title.includes(q);
            c.hidden = !hit;
            if (hit) shown++;
          });
          this.els.none.hidden = shown > 0;
        }

        /* Keep the mobile bundle bar above any fixed bottom navigation of the theme */
        measureOffset() {
          let off = 0;
          if (!window.matchMedia('(min-width: 990px)').matches) {
            off = Number(this.cfg.bottomOffset) || 0;
            const H = window.innerHeight;
            const W = window.innerWidth;
            [4, 24, 44, 64].forEach((dy) => {
              document.elementsFromPoint(W / 2, H - dy).forEach((el) => {
                if (this.contains(el) || el === document.documentElement || el === document.body) return;
                let n = el;
                while (n && n !== document.body) {
                  const cs = getComputedStyle(n);
                  if (cs.position === 'fixed' || cs.position === 'sticky') {
                    const r = n.getBoundingClientRect();
                    if (r.width > W * 0.5 && r.height < 220 && r.bottom > H - 100 && r.top > H * 0.45) off = Math.max(off, Math.ceil(H - r.top));
                    break;
                  }
                  n = n.parentElement;
                }
              });
            });
          }
          this.style.setProperty('--bb-bottom-offset', off + 'px');
        }

        /* sliding highlight behind the discount level that is currently unlocked */
        moveThumb(instant) {
          const th = this.els.thumb;
          if (!th) return;
          const a = this.activeIdx();
          if (a < 0) { th.style.opacity = '0'; return; }
          const btn = this.querySelector(`[data-tier="${a}"]`);
          if (!btn) return;
          if (instant) th.style.transition = 'none';
          th.style.opacity = '1';
          th.style.width = btn.offsetWidth + 'px';
          th.style.transform = `translateX(${btn.offsetLeft}px)`;
          if (instant) { void th.offsetWidth; th.style.transition = ''; }
          else if (this.els.tiers.scrollWidth > this.els.tiers.clientWidth) btn.scrollIntoView({ inline: 'center', block: 'nearest', behavior: this.reduce ? 'auto' : 'smooth' });
        }

        animateMoney(el, key, to) {
          const from = this.shown[key];
          this.shown[key] = to;
          if (from === null || from === to || this.reduce) { el.textContent = this.money(to); return; }
          const start = performance.now();
          const dur = 420;
          cancelAnimationFrame(el._raf);
          const step = (now) => {
            const p = Math.min(1, (now - start) / dur);
            const e = 1 - Math.pow(1 - p, 3);
            el.textContent = this.money(Math.round(from + (to - from) * e));
            if (p < 1) el._raf = requestAnimationFrame(step);
          };
          el._raf = requestAnimationFrame(step);
        }

        celebrate() {
          const s = this.els.summary;
          s.classList.add('is-win');
          setTimeout(() => s.classList.remove('is-win'), 1000);
          if (this.reduce) return;
          const box = document.createElement('div');
          box.className = 'bb-confetti';
          const colors = ['#ffb703', '#fb5607', '#ff006e', '#3a86ff', '#06d6a0', 'var(--bb-accent)'];
          for (let i = 0; i < 34; i++) {
            const p = document.createElement('i');
            p.style.setProperty('--c', colors[i % colors.length]);
            p.style.setProperty('--x', (Math.random() * 280 - 140).toFixed(0) + 'px');
            p.style.setProperty('--y', (Math.random() * -170 - 20).toFixed(0) + 'px');
            p.style.setProperty('--r', (Math.random() * 720 - 360).toFixed(0) + 'deg');
            p.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
            box.append(p);
          }
          s.append(box);
          setTimeout(() => box.remove(), 1500);
        }

        fly(ci, k) {
          if (this.reduce) return;
          const card = this.cards[ci];
          const src = card && card.querySelector('.bb-card__img');
          const slot = this.els.slots.children[k];
          const unit = this.units[k];
          if (!src || !slot || !unit) return;
          const target = slot.querySelector('.bb-slot__thumb') || slot;
          const a = src.getBoundingClientRect();
          const b = target.getBoundingClientRect();
          if (!a.width || !b.width) return;
          const ghost = document.createElement('img');
          ghost.className = 'bb-fly';
          ghost.alt = '';
          ghost.src = unit.v.image || src.currentSrc || src.src;
          ghost.style.cssText = `left:${a.left}px;top:${a.top}px;width:${a.width}px;height:${a.height}px;border-radius:18px`;
          document.body.append(ghost);
          const dx = b.left + b.width / 2 - (a.left + a.width / 2);
          const dy = b.top + b.height / 2 - (a.top + a.height / 2);
          const sc = b.width / a.width;
          const an = ghost.animate(
            [{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: `translate(${dx * 0.5}px,${dy * 0.5 - 40}px) scale(${(1 + sc) / 2})`, opacity: 1, offset: 0.55 }, { transform: `translate(${dx}px,${dy}px) scale(${sc})`, opacity: 0.9 }],
            { duration: 640, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' }
          );
          an.onfinish = an.oncancel = () => {
            ghost.remove();
            slot.classList.add('is-pop');
            setTimeout(() => slot.classList.remove('is-pop'), 600);
          };
        }

        /* ---------- events ---------- */
        onClick(e) {
          const t = e.target;
          const card = t.closest('[data-card]');
          if (card) {
            const ci = Number(card.dataset.index);
            if (t.closest('[data-add]') || t.closest('[data-inc]') || t.closest('[data-open]')) return this.pick(ci);
            if (t.closest('[data-dec]')) {
              for (let k = this.units.length - 1; k >= 0; k--) if (this.units[k].ci === ci) { this.units.splice(k, 1); break; }
              this.say(''); return this.render();
            }
          }
          const rm = t.closest('[data-remove]');
          if (rm) { this.units.splice(Number(rm.dataset.remove), 1); this.say(''); return this.render(); }
          const ed = t.closest('[data-edit]');
          if (ed) { const u = this.units[Number(ed.dataset.edit)]; if (u) this.openModal(u, false, true); return; }
          if (t.closest('[data-toggle]')) {
            const open = this.els.summary.classList.toggle('is-open');
            t.closest('[data-toggle]').setAttribute('aria-expanded', String(open));
            return;
          }
          const tr = t.closest('[data-tr]');
          if (tr) return this.translateField(tr);
          if (t.closest('[data-copy]')) return this.copyPrev();
          if (t.closest('[data-modal-close]')) return this.modal.close();
          if (t.closest('[data-clear]')) { this.units = []; this.say(''); return this.render(); }
          if (t.closest('[data-submit]')) return this.submit();
        }

        /* ---------- variants ---------- */
        vdata(v) { return { id: v.id, price: v.price, compare: v.compare, image: v.image || '', title: v.title === 'Default Title' ? '' : v.title }; }
        firstAvailable(pj) { return pj.variants.find((v) => v.available) || null; }

        /* ---------- picking a product ---------- */
        async pick(ci) {
          if (this.loading || this.total >= this.maxItems) return;
          const card = this.cards[ci];
          const pj = this.pjs[ci];
          if (card.dataset.soldout === 'true') return;
          if (!this.cfg.allowRepeat && this.qtyOf(ci) >= 1) return;
          const first = this.firstAvailable(pj);
          if (!first) return;

          const unit = { ci, v: this.vdata(first), name: card.dataset.name, defs: [], fields: [] };
          const needsPopup = pj.variants.length > 1;

          if (this.cfg.fieldsMode === 'off') {
            if (!needsPopup) return this.commit(unit);
            return this.openModal(unit, true, false);
          }
          if (needsPopup) return this.openModal(unit, true, false);

          // single-variant product: only open the popup if it has customization fields
          this.loading = true;
          card.classList.add('is-loading');
          let defs = [];
          try { defs = await this.resolveFields(card.dataset.url, true); } catch (_) { defs = []; }
          card.classList.remove('is-loading');
          this.loading = false;
          if (!defs.length) return this.commit(unit);
          unit.defs = defs;
          this.openModal(unit, true, true);
        }

        commit(unit) {
          this.units.push(unit);
          this.say('');
          this.render();
          this.fly(unit.ci, this.units.length - 1);
        }

        /* ---------- field detection ---------- */
        parseFallback() {
          return (this.cfg.fallbackFields || '')
            .split('\n').map((l) => l.trim()).filter(Boolean)
            .map((line) => {
              const [label, type, req] = line.split('|').map((x) => (x || '').trim());
              const ty = (type || '').toLowerCase();
              return { name: label, label, type: ['text', 'textarea', 'file', 'number', 'email', 'tel', 'date'].includes(ty) ? ty : 'text', required: /^req/i.test(req || ''), options: [] };
            });
        }

        loadStatic(url) {
          const c = this.cache[url] || (this.cache[url] = {});
          if (!c.stat) c.stat = this.fetchStatic(url).catch(() => []);
          return c.stat;
        }
        loadRendered(url) {
          const c = this.cache[url] || (this.cache[url] = {});
          if (!c.rend) c.rend = this.fetchRendered(url).catch(() => []);
          return c.rend;
        }

        async resolveFields(url, waitRendered) {
          if (this.cfg.fieldsMode === 'custom') return this.parseFallback();
          let defs = await this.loadStatic(url);
          if (!defs.length && waitRendered && this.cfg.deepScan) defs = await this.loadRendered(url);
          return defs.length ? defs : this.parseFallback();
        }

        labelFor(el, doc, fallback) {
          let lab = null;
          if (el.id) lab = doc.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]');
          if (!lab) lab = el.closest('label');
          const text = (lab ? lab.textContent : '').replace(/\s+/g, ' ').replace(/\*/g, '').trim();
          return text || el.getAttribute('aria-label') || el.getAttribute('placeholder') || fallback;
        }

        extract(doc) {
          const map = new Map();
          const out = [];
          doc.querySelectorAll('[name^="properties["]').forEach((el) => {
            const m = (el.getAttribute('name') || '').match(/^properties\[(.+)\]$/);
            if (!m) return;
            const name = m[1];
            if (name.startsWith('_') || ['hidden', 'submit', 'button'].includes(el.type)) return;
            if (el.closest('product-recommendations, [class*="recommend"], [class*="related"], .card-wrapper, .quick-add, quick-add-modal, cart-drawer, .cart-drawer')) return;
            let d = map.get(name);
            if (!d) {
              d = { name, label: name, type: 'text', required: false, options: [], placeholder: el.getAttribute('placeholder') || '', maxlength: el.getAttribute('maxlength') || '', accept: el.getAttribute('accept') || '' };
              map.set(name, d); out.push(d);
            }
            if (el.required || el.getAttribute('aria-required') === 'true') d.required = true;
            if (el.type === 'radio') {
              d.type = 'radio';
              d.options.push({ value: el.value, label: this.labelFor(el, doc, el.value) });
            } else if (el.tagName === 'SELECT') {
              d.type = 'select'; d.label = this.labelFor(el, doc, name);
              d.options = Array.from(el.options).map((o) => ({ value: o.value, label: o.textContent.trim() }));
            } else if (el.type === 'checkbox') {
              d.type = 'checkbox'; d.label = this.labelFor(el, doc, name);
              d.checkedValue = el.value && el.value !== 'on' ? el.value : 'Yes';
            } else if (el.type === 'file') {
              d.type = 'file'; d.label = this.labelFor(el, doc, name);
            } else if (el.tagName === 'TEXTAREA') {
              d.type = 'textarea'; d.label = this.labelFor(el, doc, name);
            } else {
              d.type = ['number', 'email', 'tel', 'date', 'url'].includes(el.type) ? el.type : 'text';
              d.label = this.labelFor(el, doc, name);
            }
          });
          return out;
        }

        async fetchStatic(url) {
          const res = await fetch(url, { credentials: 'same-origin' });
          if (!res.ok) return [];
          return this.extract(new DOMParser().parseFromString(await res.text(), 'text/html'));
        }

        /* Loads the product page in a hidden same-site frame so fields added by apps/JavaScript are found too */
        fetchRendered(url) {
          return new Promise((resolve) => {
            if (!this.cfg.deepScan) return resolve([]);
            const f = document.createElement('iframe');
            f.setAttribute('aria-hidden', 'true');
            f.tabIndex = -1;
            f.style.cssText = 'position:fixed;left:-99999px;top:0;width:1100px;height:900px;border:0;opacity:0;pointer-events:none';
            let latest = [];
            let last = -1;
            let stable = 0;
            let iv = null;
            let done = false;
            const finish = () => { if (done) return; done = true; clearInterval(iv); clearTimeout(to); f.remove(); resolve(latest); };
            const to = setTimeout(finish, 7000);
            f.addEventListener('load', () => {
              iv = setInterval(() => {
                try {
                  const doc = f.contentDocument;
                  if (!doc) return finish();
                  latest = this.extract(doc);
                } catch (_) { return finish(); }
                stable = latest.length === last ? stable + 1 : 0;
                last = latest.length;
                if (stable >= 3) finish();
              }, 400);
            });
            f.addEventListener('error', finish);
            f.src = url;
            document.body.append(f);
          });
        }

        /* ---------- "without customization" detection ---------- */
        isNoCustom(text) {
          const s = String(text || '').toLowerCase();
          return this.cfg.noCustom.some((k) => s.includes(k));
        }

        applyCustomState() {
          const ed = this.editing;
          if (!ed) return;
          let off = this.sel.some((v) => this.isNoCustom(v));
          const ctrl = new Set();
          ed.defs.forEach((d, i) => {
            if (d.type !== 'select' && d.type !== 'radio') return;
            if (!d.options.some((o) => this.isNoCustom(o.value) || this.isNoCustom(o.label))) return;
            ctrl.add(i);
            const w = this.mFields.querySelector(`[data-i="${i}"]`);
            if (!w) return;
            const cs = Array.from(w.querySelectorAll('[data-k="v"]'));
            const val = d.type === 'radio' ? (cs.find((x) => x.checked) || {}).value : cs[0] && cs[0].value;
            if (val && this.isNoCustom(val)) off = true;
          });
          ed.off = off;

          // Urdu font chosen (variant option or a font select/radio)? Then offer "Translate to Urdu"
          const isUrdu = (t) => this.cfg.urduWords.some((k) => String(t || '').toLowerCase().includes(k));
          let urdu = this.sel.some(isUrdu);
          ed.defs.forEach((d, i) => {
            if (d.type !== 'select' && d.type !== 'radio') return;
            const w = this.mFields.querySelector(`[data-i="${i}"]`);
            if (!w) return;
            const cs = Array.from(w.querySelectorAll('[data-k="v"]'));
            const val = d.type === 'radio' ? (cs.find((x) => x.checked) || {}).value : cs[0] && cs[0].value;
            if (!val) return;
            const opt = d.options.find((o) => o.value === val);
            if (isUrdu(val) || (opt && isUrdu(opt.label))) urdu = true;
          });
          let visible = 0;
          this.mFields.querySelectorAll('.bb-field').forEach((w) => {
            const i = Number(w.dataset.i);
            const hide = off && !ctrl.has(i);
            w.hidden = hide;
            if (!hide && !ctrl.has(i)) visible++;
          });
          this.mFields.querySelectorAll('.bb-tr').forEach((r) => { r.hidden = !urdu || off || (r.closest('.bb-field') || {}).hidden === true; });
          if (this.mAdvance) this.mAdvance.hidden = !(visible > 0);
          const note = this.$('[data-note]');
          if (note) note.hidden = !(visible > 0) && ed.defs.length > 0 && off;
          this.mCopyRow.hidden = !(visible > 0 && ed.isNew && this.units.some((u) => u !== ed.unit && u.fields.length));
        }

        /* ---------- popup ---------- */
        openModal(unit, isNew, haveDefs) {
          const pj = this.pjs[unit.ci];
          const card = this.cards[unit.ci];
          this.token++;
          const token = this.token;
          this.editing = { unit, isNew, token, pj, defs: unit.defs.slice(), ready: false, off: false };
          this.sel = (pj.variants.find((v) => v.id === unit.v.id) || pj.variants[0]).opts.slice();

          this.$('[data-modal-title]').textContent = this.cfg.modalTitle || 'Customize your product';
          this.$('[data-modal-product]').textContent = unit.name;
          this.mSave.textContent = isNew ? this.cfg.modalSave || 'Add to bundle' : 'Save changes';
          this.mError.textContent = '';
          this.mFields.textContent = '';
          if (this.mAdvance) this.mAdvance.hidden = true;
          this.mCopyRow.hidden = true;
          this.renderOptions(pj);
          this.refreshVariant();

          if (haveDefs) {
            this.renderFields(this.editing.defs, unit.fields);
            this.setReady(true);
            this.applyCustomState();
          } else {
            this.setReady(false);
          }
          this.modal.showModal();

          if (!haveDefs) {
            if (this.cfg.fieldsMode === 'off') { this.setReady(true); return; }
            this.resolveFields(card.dataset.url, true).then((defs) => {
              if (!this.editing || this.editing.token !== token) return;
              this.editing.defs = defs.slice();
              this.renderFields(this.editing.defs, []);
              this.setReady(true);
              this.applyCustomState();
            });
          }

          // merge in extra fields that only appear once the page's JavaScript has run
          if (this.cfg.fieldsMode === 'auto' && this.cfg.deepScan) {
            this.loadRendered(card.dataset.url).then((rd) => this.deferMerge(token, rd));
          }
        }

        deferMerge(token, rd) {
          let tries = 0;
          const t = setInterval(() => {
            tries++;
            if (!this.editing || this.editing.token !== token) return clearInterval(t);
            if (this.editing.ready) { clearInterval(t); this.mergeFields(rd); }
            if (tries > 40) clearInterval(t);
          }, 250);
        }

        mergeFields(rd) {
          const cur = this.editing.defs;
          const extra = rd.filter((d) => !cur.some((x) => x.name === d.name));
          if (!extra.length) return;
          const start = cur.length;
          cur.push(...extra);
          extra.forEach((d, k) => this.mFields.append(this.buildField(d, start + k, null)));
          this.applyCustomState();
        }

        setReady(ok) {
          if (this.editing) this.editing.ready = ok;
          this.mLoading.hidden = ok;
          this.mSave.disabled = !ok || !this.currentVariantOk;
        }

        renderOptions(pj) {
          const box = this.mOpts;
          box.textContent = '';
          if (pj.variants.length < 2) { box.hidden = true; return; }
          box.hidden = false;
          pj.options.forEach((o, oi) => {
            const fs = document.createElement('fieldset');
            fs.className = 'bb-opt';
            const lg = document.createElement('legend');
            lg.innerHTML = `${this.esc(o.name)}: <b data-sel="${oi}">${this.esc(this.sel[oi])}</b>`;
            const row = document.createElement('div');
            row.className = 'bb-opt__row';
            const isColor = /colou?r/i.test(o.name);
            o.values.forEach((val, vi) => {
              const id = `bbo-${this.uid}-${oi}-${vi}`;
              const inp = document.createElement('input');
              inp.type = 'radio'; inp.name = `bbo-${this.uid}-${oi}`; inp.id = id; inp.value = val; inp.dataset.oi = oi;
              inp.checked = this.sel[oi] === val;
              const lab = document.createElement('label');
              lab.className = 'bb-pill';
              lab.htmlFor = id;
              lab.dataset.v = val; lab.dataset.o = oi;
              if (isColor) {
                const cands = [val, val.replace(/\s+/g, ''), val.split(' ').pop(), val.split(' ')[0]];
                const c = cands.find((x) => window.CSS && CSS.supports('color', x));
                if (c) { const dot = document.createElement('i'); dot.style.background = c; lab.append(dot); }
              }
              lab.append(document.createTextNode(val));
              row.append(inp, lab);
            });
            fs.append(lg, row);
            box.append(fs);
          });
        }

        refreshVariant() {
          const { pj, unit } = this.editing;
          const v = pj.variants.find((x) => x.opts.every((o, i) => o === this.sel[i]));
          this.currentVariantOk = !!(v && v.available);
          if (v) {
            const vd = this.vdata(v);
            this.editing.v = vd;
            const img = this.$('[data-modal-img]');
            if (v.image) { img.src = v.image; img.hidden = false; } else img.hidden = true;
            this.$('[data-modal-price]').innerHTML = this.money(v.price) + (v.compare > v.price ? `<s>${this.money(v.compare)}</s>` : '');
            this.$('[data-modal-product]').textContent = unit.name + (vd.title ? ' — ' + vd.title : '');
          } else {
            this.$('[data-modal-price]').textContent = '';
          }
          this.querySelectorAll('[data-sel]').forEach((b) => { b.textContent = this.sel[Number(b.dataset.sel)]; });
          this.querySelectorAll('.bb-pill').forEach((p) => {
            const oi = Number(p.dataset.o);
            const val = p.dataset.v;
            const ok = pj.variants.some((x) => x.available && x.opts[oi] === val && x.opts.every((o, i) => i === oi || o === this.sel[i]));
            p.classList.toggle('is-out', !ok);
          });
          if (!this.currentVariantOk && pj.variants.length > 1) this.mError.textContent = v ? 'This option is sold out. Please choose another.' : 'This combination is not available.';
          else if (this.mError.textContent.startsWith('This ')) this.mError.textContent = '';
          this.mSave.disabled = !this.editing.ready || !this.currentVariantOk;
          if (this.editing.ready) this.applyCustomState();
        }

        buildField(d, i, prev) {
          const id = `bbf-${this.uid}-${i}`;
          const wrap = document.createElement(d.type === 'radio' ? 'fieldset' : 'div');
          wrap.className = 'bb-field';
          wrap.dataset.i = i;
          const star = d.required ? ' <span class="bb-field__req" aria-hidden="true">*</span>' : '';
          const head = document.createElement(d.type === 'radio' ? 'legend' : 'label');
          if (d.type !== 'radio') head.setAttribute('for', id);

          if (d.type === 'checkbox') {
            const row = document.createElement('label');
            row.className = 'bb-field__opt';
            const cb = document.createElement('input');
            cb.type = 'checkbox'; cb.id = id; cb.dataset.k = 'v'; cb.required = d.required;
            cb.checked = !!(prev && prev.value);
            row.append(cb, document.createTextNode(d.label));
            wrap.append(row);
          } else if (d.type === 'radio') {
            head.innerHTML = this.esc(d.label) + star;
            wrap.append(head);
            d.options.forEach((o) => {
              const row = document.createElement('label');
              row.className = 'bb-field__opt';
              const r = document.createElement('input');
              r.type = 'radio'; r.name = id; r.value = o.value; r.dataset.k = 'v'; r.required = d.required;
              r.checked = !!(prev && prev.value === o.value);
              row.append(r, document.createTextNode(o.label));
              wrap.append(row);
            });
          } else {
            head.innerHTML = this.esc(d.label) + star;
            wrap.append(head);
            let c;
            if (d.type === 'textarea') c = document.createElement('textarea');
            else if (d.type === 'select') {
              c = document.createElement('select');
              d.options.forEach((o) => { const op = document.createElement('option'); op.value = o.value; op.textContent = o.label; c.append(op); });
            } else { c = document.createElement('input'); c.type = d.type; }
            c.id = id; c.dataset.k = 'v'; c.required = d.required;
            if (d.placeholder) c.placeholder = d.placeholder;
            if (d.maxlength) c.maxLength = Number(d.maxlength);
            const textual = d.type === 'text' || d.type === 'textarea';
            if (textual) c.dir = 'auto';
            if (d.type === 'file') {
              c.accept = d.accept || 'image/*';
              wrap.append(c);
              if (prev && prev.file) {
                c.required = false;
                const help = document.createElement('span');
                help.className = 'bb-field__help';
                help.textContent = 'Current file: ' + prev.file.name + ' (choose another to replace it)';
                wrap.append(help);
              }
            } else {
              if (prev) { c.value = prev.value; if (prev.orig) c.dataset.orig = prev.orig; }
              wrap.append(c);
              if (textual && d.maxlength) {
                const cnt = document.createElement('span');
                cnt.className = 'bb-field__count';
                cnt.textContent = `${c.value.length}/${d.maxlength}`;
                wrap.append(cnt);
              }
              if (textual && this.cfg.translate && !/instruction|note|comment|remark|special|address|phone|email|whatsapp|order/i.test(d.label + ' ' + d.name)) {
                const row = document.createElement('div');
                row.className = 'bb-tr';
                row.hidden = true; // shown only when an Urdu / Arabic font style is chosen
                row.innerHTML = '<button type="button" data-tr="ur"><span class="bb-tr__ur" lang="ur">اردو</span><span>Translate to Urdu</span></button>';
                wrap.append(row);
              }
            }
          }
          return wrap;
        }

        renderFields(defs, prevFields) {
          this.mFields.textContent = '';
          defs.forEach((d, i) => this.mFields.append(this.buildField(d, i, prevFields.find((f) => f.name === d.name) || null)));
        }

        /* ---------- Urdu / Arabic helper ---------- */
        async translateField(btn) {
          const wrap = btn.closest('.bb-field');
          const c = wrap && wrap.querySelector('[data-k="v"]');
          if (!c) return;
          const lang = btn.dataset.tr;
          const hasArabic = (s) => /[\u0600-\u06FF]/.test(s);
          const old = wrap.querySelector('.bb-field__help.is-error');
          if (old) old.remove();

          if (!hasArabic(c.value)) c.dataset.orig = c.value;
          const src = (c.dataset.orig || c.value || '').trim();
          if (!src) return;

          const buttons = wrap.querySelectorAll('[data-tr]');
          buttons.forEach((b) => (b.disabled = true));
          const label = btn.innerHTML;
          btn.textContent = 'Translating…';
          try {
            const out = await this.transliterate(src, lang);
            if (!out) throw new Error('empty');
            c.value = c.maxLength > 0 ? out.slice(0, c.maxLength) : out;
            c.dir = 'auto';
            c.dispatchEvent(new Event('input', { bubbles: true }));
          } catch (_) {
            const h = document.createElement('span');
            h.className = 'bb-field__help is-error';
            h.textContent = 'Could not translate right now. Please try again or type it in Urdu.';
            wrap.append(h);
          }
          btn.innerHTML = label;
          buttons.forEach((b) => (b.disabled = false));
        }

        async transliterate(text, lang) {
          const parts = text.split(/(\s+)/);
          const conv = await Promise.all(parts.map(async (w) => {
            if (!w.trim() || /^[\d\W]+$/.test(w) || /[\u0600-\u06FF]/.test(w)) return w;
            try {
              const r = await fetch(`https://inputtools.google.com/request?text=${encodeURIComponent(w)}&itc=${lang}-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8`);
              const j = await r.json();
              if (j[0] === 'SUCCESS' && j[1] && j[1][0] && j[1][0][1] && j[1][0][1][0]) return j[1][0][1][0];
            } catch (_) {}
            return null;
          }));
          if (!conv.some((x) => x === null)) return conv.join('');
          // fallback: machine translation
          const r = await fetch(`https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${lang}`);
          const j = await r.json();
          return j && j.responseData && j.responseData.translatedText ? j.responseData.translatedText : '';
        }

        copyPrev() {
          const ed = this.editing;
          if (!ed) return;
          const src = [...this.units].reverse().find((u) => u !== ed.unit && u.fields.length);
          if (!src) return;
          ed.defs.forEach((d, i) => {
            const f = src.fields.find((x) => x.name.toLowerCase() === d.name.toLowerCase());
            if (!f || d.type === 'file') return;
            const w = this.mFields.querySelector(`[data-i="${i}"]`);
            if (!w) return;
            const cs = Array.from(w.querySelectorAll('[data-k="v"]'));
            if (d.type === 'radio') cs.forEach((r) => { r.checked = r.value === f.value; });
            else if (d.type === 'checkbox') cs[0].checked = !!f.value;
            else { cs[0].value = f.value; if (f.orig) cs[0].dataset.orig = f.orig; cs[0].dispatchEvent(new Event('input', { bubbles: true })); }
          });
          this.applyCustomState();
        }

        saveModal() {
          const ed = this.editing;
          if (!ed || !ed.ready || !this.currentVariantOk) return;
          const { unit, isNew, defs } = ed;
          let ok = true;
          const fields = [];
          defs.forEach((d, i) => {
            const wrap = this.mFields.querySelector(`[data-i="${i}"]`);
            if (!wrap || wrap.hidden) return; // hidden when "without customization" is chosen
            const controls = Array.from(wrap.querySelectorAll('[data-k="v"]'));
            const prev = unit.fields.find((f) => f.name === d.name);
            let value = '';
            let file = null;
            if (d.type === 'radio') { const r = controls.find((x) => x.checked); value = r ? r.value : ''; }
            else if (d.type === 'checkbox') { value = controls[0].checked ? d.checkedValue || 'Yes' : ''; }
            else if (d.type === 'file') {
              file = controls[0].files && controls[0].files[0] ? controls[0].files[0] : prev && prev.file ? prev.file : null;
              value = file ? file.name : '';
            } else value = controls[0].value.trim();
            const missing = d.required && !value;
            wrap.classList.toggle('is-invalid', missing);
            if (missing) ok = false;
            if (value || file) fields.push({ name: d.name, label: d.label, value, file, orig: controls[0] && controls[0].dataset ? controls[0].dataset.orig : undefined });
          });
          if (!ok) { this.mError.textContent = 'Please fill in the required fields.'; return; }
          unit.fields = fields;
          unit.defs = defs;
          if (ed.v) unit.v = ed.v;
          this.modal.close();
          if (isNew) this.commit(unit);
          else { this.say(''); this.render(); }
        }

        /* ---------- render ---------- */
        render() {
          const tiers = this.cfg.tiers;
          const count = this.total;
          const a = this.activeIdx();
          const pct = a >= 0 ? tiers[a].percent : 0;

          this.querySelectorAll('[data-tier]').forEach((b, i) => {
            const t = tiers[i];
            b.classList.toggle('is-reached', count >= t.qty);
            b.classList.toggle('is-active', i === a);
            b.querySelector('[data-tier-price]').innerHTML = `${t.percent}<small>% off</small>`;
            b.querySelector('[data-tier-each]').textContent = `Any ${t.qty} products`;
          });

          let value = 0;
          this.units.forEach((u) => { value += u.v.price; });

          this.cards.forEach((card, i) => {
            const q = this.qtyOf(i);
            const sold = card.dataset.soldout === 'true';
            const add = card.querySelector('[data-add]');
            const step = card.querySelector('[data-step]');
            const badge = card.querySelector('[data-qty-badge]');
            card.classList.toggle('is-selected', q > 0);
            add.hidden = q > 0;
            step.hidden = q === 0;
            if (q === 0) add.disabled = sold || count >= this.maxItems;
            card.querySelector('[data-qty]').textContent = q;
            const wasHidden = badge.hidden;
            badge.hidden = q === 0;
            if (q > 0) { badge.textContent = '×' + q; if (!wasHidden) { badge.style.animation = 'none'; void badge.offsetWidth; badge.style.animation = ''; } }
            card.querySelector('[data-inc]').disabled = count >= this.maxItems || !this.cfg.allowRepeat || sold;
          });

          const slotCount = Math.min(this.maxItems, Math.max(this.minQty, count < this.topQty ? count + 1 : count));
          const slots = [];
          for (let k = 0; k < slotCount; k++) {
            const u = this.units[k];
            if (u) {
              const sum = u.fields.map((f) => (f.file ? f.file.name : f.value)).filter(Boolean).slice(0, 2).join(' · ');
              const canEdit = (u.defs && u.defs.length) || this.pjs[u.ci].variants.length > 1;
              const thumb = `<img class="bb-slot__thumb" src="${this.esc(u.v.image)}" alt="" width="52" height="52" loading="lazy">`;
              slots.push(
                `<li class="bb-slot">` +
                (canEdit ? `<button type="button" class="bb-slot__thumbbtn" data-edit="${k}" aria-label="Edit ${this.esc(u.name)}">${thumb}</button>` : thumb) +
                `<span class="bb-slot__name">${this.esc(u.name)}${u.v.title ? `<small>${this.esc(u.v.title)}</small>` : ''}${sum ? `<small>${this.esc(sum)}</small>` : ''}` +
                `${canEdit ? `<button type="button" class="bb-slot__edit" data-edit="${k}">Edit details</button>` : ''}</span>` +
                `<button type="button" class="bb-slot__x" data-remove="${k}" aria-label="Remove ${this.esc(u.name)}">×</button></li>`
              );
            } else {
              slots.push(`<li class="bb-slot bb-slot--empty"><span class="bb-slot__thumb">+</span><span class="bb-slot__name">${k < this.minQty ? 'Choose a product' : 'Add one more for a bigger discount'}</span></li>`);
            }
          }
          this.els.slots.innerHTML = slots.join('');

          const save = Math.round((value * pct) / 100);
          const bundle = value - save;
          this.els.count.textContent = count === 1 ? '1 item' : `${count} items`;
          const fill = Math.min(100, Math.round((count / this.topQty) * 100));
          this.els.bar.style.width = fill + '%';
          this.els.progress.setAttribute('aria-valuenow', fill);
          this.els.progress.querySelectorAll('.bb-tick').forEach((tk, i) => { tk.dataset.qty = tiers[i] ? tiers[i].qty : ''; });
          this.els.rowValue.hidden = save <= 0;
          this.els.value.innerHTML = save > 0 ? `<s>${this.money(value)}</s>` : this.money(value);
          this.animateMoney(this.els.total, 'total', bundle);
          this.els.pct.hidden = pct <= 0;
          this.els.pct.textContent = `${pct}% off`;
          this.els.rowSave.hidden = save <= 0;
          if (save > 0) this.animateMoney(this.els.save, 'save', save); else this.shown.save = null;
          this.els.clear.hidden = count === 0;

          const nxt = this.nextTier();
          if (count < this.minQty) this.els.hint.textContent = `Add ${this.minQty - count} more product${this.minQty - count > 1 ? 's' : ''} to unlock ${tiers.find((t) => t.qty === this.minQty).percent}% off.`;
          else if (nxt) this.els.hint.textContent = `${pct}% off unlocked! Add ${nxt.qty - count} more for ${nxt.percent}% off.`;
          else this.els.hint.textContent = `Best discount unlocked: ${pct}% off your bundle!`;

          const btn = this.els.submit;
          btn.disabled = count < this.minQty || this.busy;
          if (count < this.minQty) { this.els.label.textContent = `Add ${this.minQty - count} more`; this.els.price.textContent = ''; }
          else { this.els.label.textContent = 'Add to cart'; this.els.price.textContent = this.money(bundle); }

          if (a > this.prevActive && a >= 0) this.celebrate();
          this.prevActive = a;
          this.moveThumb();
        }

        /* ---------- add to cart (one request per product so each keeps its own options and details) ---------- */
        async submit() {
          if (this.busy || this.total < this.minQty) return;
          this.busy = true;
          const btn = this.els.submit;
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
          this.say('Adding your bundle…');

          const a = this.activeIdx();
          const tier = this.cfg.tiers[a];
          let value = 0;
          this.units.forEach((u) => { value += u.v.price; });
          const saved = Math.round((value * tier.percent) / 100);
          const bundleId = 'bb' + Date.now().toString(36);
          const drawer = this.cfg.afterAdd === 'drawer' ? document.querySelector('cart-drawer') : null;
          const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.section).join(',') : '';
          const list = this.units.slice();
          let done = 0;
          let last = null;

          try {
            for (let k = 0; k < list.length; k++) {
              const u = list[k];
              const fd = new FormData();
              fd.append('id', u.v.id);
              fd.append('quantity', 1);
              fd.append('properties[Bundle]', `Bundle of ${list.length} · ${tier.percent}% off`);
              fd.append('properties[_bundle_id]', bundleId);
              fd.append('properties[_bundle_percent]', tier.percent);
              u.fields.forEach((f) => fd.append(`properties[${f.name}]`, f.file ? f.file : f.value));
              if (k === list.length - 1 && sections) { fd.append('sections', sections); fd.append('sections_url', window.location.pathname); }

              const res = await fetch(this.cfg.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
              const data = await res.json();
              if (!res.ok) throw new Error(data.description || data.message || 'Could not add this product.');
              last = data;
              done++;
            }

            if (tier.code) { try { await fetch(this.cfg.root + 'discount/' + encodeURIComponent(tier.code), { credentials: 'same-origin' }); } catch (_) {} }

            this.units = [];
            this.say('');
            if (this.cfg.afterAdd === 'checkout') { window.location.href = '/checkout' + (tier.code ? '?discount=' + encodeURIComponent(tier.code) : ''); return; }
            if (drawer && typeof drawer.renderContents === 'function' && last && last.sections) {
              try { drawer.renderContents(last); } catch (_) { window.location.href = this.cfg.cartUrl; return; }
              this.say(`Bundle added ✓ You saved ${this.money(saved)}`);
            } else { window.location.href = this.cfg.cartUrl; return; }
          } catch (err) {
            this.units = list.slice(done);
            this.say((done ? `${done} of ${list.length} products were added. ` : '') + (err.message || 'Something went wrong. Please try again.'), true);
          } finally {
            this.busy = false;
            btn.removeAttribute('aria-busy');
            this.render();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-reviews-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function show(d) {
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
  }

  function measure(root) {
    (root || document).querySelectorAll('.rw-text').forEach(function (t) {
      var more = t.parentNode.querySelector('.rw-more');
      if (more) more.hidden = !(t.scrollHeight > t.clientHeight + 1);
    });
  }

  function openLightbox(card) {
    var rw = card.closest('.rw');
    if (!rw) return;
    var dlg = rw.querySelector('.rw-lb');
    var body = dlg.querySelector('.rw-lb__body');
    var clone = card.cloneNode(true);
    clone.removeAttribute('tabindex');
    clone.removeAttribute('role');
    clone.classList.remove('rw-extra');
    var media = clone.querySelector('.rw-card__media');
    if (media && media.getAttribute('data-full')) {
      var img = media.querySelector('img');
      if (img) {
        img.src = media.getAttribute('data-full');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('loading');
      }
    }
    var more = clone.querySelector('.rw-more');
    if (more) more.remove();
    body.innerHTML = '';
    body.appendChild(clone);
    show(dlg);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.nodeName === 'DIALOG') { t.close(); return; }

    var rmBtn = t.closest('[data-rw-remove]');
    if (rmBtn) {
      var rf = rmBtn.closest('form');
      if (rf && rf._rwFiles) {
        rf._rwFiles.splice(parseInt(rmBtn.getAttribute('data-rw-remove'), 10), 1);
        renderThumbs(rf);
      }
      return;
    }

    var openForm = t.closest('[data-rw-open-form]');
    if (openForm) {
      var f = openForm.closest('.rw').querySelector('.rw-form');
      if (f) show(f);
      return;
    }

    var closeBtn = t.closest('[data-rw-close]');
    if (closeBtn) {
      var d = closeBtn.closest('dialog');
      if (d) d.close();
      return;
    }

    var moreBtn = t.closest('[data-rw-more]');
    if (moreBtn) {
      var root = moreBtn.closest('.rw');
      var step = parseInt(moreBtn.getAttribute('data-step'), 10) || 12;
      var hidden = root.querySelectorAll('.rw-card.rw-extra');
      for (var i = 0; i < hidden.length && i < step; i++) hidden[i].classList.remove('rw-extra');
      measure(root);
      if (!root.querySelector('.rw-card.rw-extra')) moreBtn.parentNode.hidden = true;
      return;
    }

    var card = t.closest('.rw-card');
    if (card && card.closest('.rw__grid')) openLightbox(card);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if ((e.key === 'Enter' || e.key === ' ') && t.classList && t.classList.contains('rw-card')) {
      e.preventDefault();
      openLightbox(t);
    }
  });

  /* ---------- Review form: photos + submit without page reload ---------- */
  function isImg(f) {
    return (f.type && f.type.indexOf('image/') === 0) || /\.(jpe?g|png|webp|heic|heif|gif)$/i.test(f.name || '');
  }

  function cfg(form) {
    var m = form.querySelector('[data-rw-msgs]');
    function g(k) { return (m && m.getAttribute(k)) || ''; }
    return {
      cloud: g('data-cloud'),
      preset: g('data-preset'),
      folder: g('data-folder'),
      max: parseInt(g('data-max'), 10) || 3,
      sending: g('data-sending') || 'Sending...',
      error: g('data-error') || 'Something went wrong. Please try again.',
      photoError: g('data-photo-error') || 'Photo could not be uploaded.'
    };
  }

  function renderThumbs(form) {
    var list = form.querySelector('.rw-thumbs');
    if (!list) return;
    var files = form._rwFiles || [];
    list.innerHTML = '';
    files.forEach(function (f, i) {
      var box = document.createElement('div');
      box.className = 'rw-thumb';
      var img = document.createElement('img');
      img.alt = '';
      var url = URL.createObjectURL(f);
      img.onload = function () { URL.revokeObjectURL(url); };
      img.src = url;
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'rw-thumb__x';
      rm.setAttribute('data-rw-remove', i);
      rm.setAttribute('aria-label', 'Remove photo');
      rm.innerHTML = '&times;';
      box.appendChild(img);
      box.appendChild(rm);
      list.appendChild(box);
    });
    var pick = form.querySelector('.rw-pick');
    if (pick) pick.hidden = files.length >= cfg(form).max;
  }

  function compress(file) {
    return new Promise(function (resolve) {
      if (!file.type || file.type.indexOf('image/') !== 0) { resolve(file); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight;
        var r = Math.min(1, 1600 / Math.max(w, h));
        if (r === 1 && file.size < 1500000) { resolve(file); return; }
        var c = document.createElement('canvas');
        c.width = Math.round(w * r);
        c.height = Math.round(h * r);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        if (c.toBlob) c.toBlob(function (b) { resolve(b || file); }, 'image/jpeg', 0.85);
        else resolve(file);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  function uploadOne(blob, c) {
    var fd = new FormData();
    fd.append('file', blob, blob.name || 'review-photo.jpg');
    fd.append('upload_preset', c.preset);
    if (c.folder) fd.append('folder', c.folder);
    return fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(c.cloud) + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.secure_url) throw new Error('upload');
        return j.secure_url;
      });
  }

  function setBusy(form, on, text) {
    var btn = form.querySelector('button[type=submit]');
    form._rwBusy = on;
    if (!btn) return;
    if (on) { btn._rwLabel = btn.textContent; btn.textContent = text; btn.disabled = true; }
    else { if (btn._rwLabel) btn.textContent = btn._rwLabel; btn.disabled = false; }
  }

  function showMsg(form, text) {
    var box = form.querySelector('.rw-status');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function send(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (typeof v === 'string') params.append(k, v); });
    return fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: params,
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (res) {
      if (res.url && res.url.indexOf('/challenge') > -1) return 'challenge';
      if (res.url && res.url.indexOf('contact_posted=true') > -1) return 'ok';
      return res.text().then(function (html) { return html.indexOf('data-rw-posted') > -1 ? 'ok' : 'fail'; });
    });
  }

  function finish(form) {
    var fields = form.querySelector('.rw-fields');
    var thanks = form.querySelector('[data-rw-thanks]');
    if (fields) fields.hidden = true;
    if (thanks) thanks.hidden = false;
    form._rwDone = true;
    setBusy(form, false);
  }

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.rw-file')) return;
    var form = inp.closest('form');
    var c = cfg(form);
    form._rwFiles = form._rwFiles || [];
    Array.prototype.forEach.call(inp.files, function (f) {
      if (form._rwFiles.length < c.max && isImg(f)) form._rwFiles.push(f);
    });
    inp.value = '';
    renderThumbs(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('.rw-form')) return;
    e.preventDefault();
    if (form._rwBusy) return;

    var c = cfg(form);
    var files = form._rwFiles || [];
    showMsg(form, '');
    setBusy(form, true, c.sending);

    var upload = (files.length && c.cloud && c.preset)
      ? Promise.all(files.map(function (f) {
          return compress(f).then(function (b) { return uploadOne(b, c); });
        })).catch(function () {
          var er = new Error('photo');
          er.rwPhoto = true;
          throw er;
        })
      : Promise.resolve([]);

    upload.then(function (urls) {
      form.querySelectorAll('input[data-rw-photo]').forEach(function (n) { n.remove(); });
      urls.forEach(function (u, i) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'contact[Photo ' + (i + 1) + ']';
        h.value = u;
        h.setAttribute('data-rw-photo', '');
        form.appendChild(h);
      });
      return send(form);
    }).then(function (result) {
      if (result === 'challenge') { form.submit(); return; }
      if (result === 'ok') { finish(form); return; }
      setBusy(form, false);
      showMsg(form, c.error);
    }).catch(function (err) {
      setBusy(form, false);
      showMsg(form, (err && err.rwPhoto) ? c.photoError : c.error);
    });
  });

  /* After a successful review, reset the form once the popup is closed */
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('rw-form')) return;
    var form = d.querySelector('form');
    if (!form || !form._rwDone) return;
    form.reset();
    form._rwFiles = [];
    form._rwDone = false;
    renderThumbs(form);
    showMsg(form, '');
    var fields = form.querySelector('.rw-fields');
    var thanks = form.querySelector('[data-rw-thanks]');
    if (fields) fields.hidden = false;
    if (thanks) thanks.hidden = true;
  }, true);

  /* Remove ?contact_posted=true from the address bar so a reload does not show the popup again */
  function cleanUrl() {
    try {
      var u = new URL(window.location.href);
      var changed = false;
      if (u.searchParams.has('contact_posted')) { u.searchParams.delete('contact_posted'); changed = true; }
      var hash = u.hash;
      if (hash.indexOf('#ReviewForm-') === 0) { hash = ''; changed = true; }
      if (changed) history.replaceState(null, '', u.pathname + u.search + hash);
    } catch (err) {}
  }

  function init(root) {
    measure(root);
    (root || document).querySelectorAll('[data-rw-autoopen]').forEach(function (m) {
      var d = m.closest('dialog');
      if (d && !d.open) {
        var sec = d.closest('.rw');
        if (sec && sec.scrollIntoView) sec.scrollIntoView();
        show(d);
        cleanUrl();
      }
    });
  }

  function ready() {
    init(document);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { measure(document); }, 150);
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
